import React from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';

import Loading from 'react-loading';
import axios from 'axios';

import ReactGA from 'react-ga';

import {IndexLink, Link, withRouter} from 'react-router';
import Splash_Signin from "../commons/splash_signin";

class UniversityProfilePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        var uniId = this.props.params.uniId

        //this.handleChange = this.handleChange.bind(this);
        this.state = {
            uniId: uniId,
            tab: "student",
            load_done: false,
            menuShow: false
        };
    }

    componentWillMount = () => {
        this.getUniversity();
    }

    componentDidMount = () => {}

    componentWillUnmount = () => {}

    componentWillReceiveProps = (nextProps) => {
        if (parseInt(this.state.uniId) !== parseInt(nextProps.params.uniId)) {
            this.setState({uniId: nextProps.params.uniId}, () => {
                this.getCompany();
            });
        } else {
            this.setState({uniId: nextProps.params.uniId});
        }

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    getUniversity = () => {
        axios.get('/code/api_university.php?api=getUniversityView&uni_id=' + this.state.uniId)
            .then(response => {
                if (response.data.status == 1) {

                    this.setState({university: response.data.data});
                }
                return response;
            });
    }

    handleClick = (act) => {
        this.props.router.push(act);
    }

    handleTabClick = (tab_name) => {
        this.setState({tab: tab_name})
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {
        if (this.state.university == undefined) {
            return (
                <div className="app_page_wrapper">
                    <div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20}
                                                         height={20}/></div>
                </div>
            );
        }
        var university = this.state.university
        var avatar = university.name_university.substring(0, 1).toUpperCase();

        if (university.id_file_university != 0) {
            avatar = university.file;
        }

        let bg_outside_url = (university.id_banner_file_university == 0 || university.id_banner_file_university == "0")
            ? '/static/img/appimg/default-banner.png'
            : university.bfile;
        var bannerURL = "/static/img/appimg/banner_student.png"
        var img1URL = "/static/img/appimg/01_student.png"
        var img2URL = "/static/img/appimg/02_student.png"

        var title01 = "Work Experience Matters"
        var text01 = "When you are launching your career, Industry projects provides many benefits. Not only can you explore different career paths and work on interesting projects, you can also demonstrate your abilities to potential employers while building your professional portfolio and network. Beyond that, your academic experience will improve as you apply what is taught in the classroom to the real world."

        var title02 = "What are Industry Projects?"
        var text02 = "Industry Projects are short-term, paid, professional assignments. These projects enable students & alumni to showcase skills, explore career paths, and build their portfolios as they seek employment. Industry projects can take place year-round, typically range from 5 to 40 hours of work, and are due between one week and one month after the start-date. Industry projects are used by companies ranging from those in the Fortune 100 to emerging start-ups, and go across departments including sales, marketing, technology, HR, and finance. "

        if (this.state.tab === "employer") {
            bannerURL = "/static/img/appimg/banner_employer.png"
            img1URL = "/static/img/appimg/01_employer.png"
            img2URL = "/static/img/appimg/02_employer.png"

            title01 = "Immediate help"
            text01 = "A Industry project is a short-term professional assignment offered by a company or organization. These paid projects can be offered at any point during the year, typically range from 5 - 40 hours of work, and are due to be completed within a week to a month from the time they are posted. Industry projects are used by a range of companies who are looking to increase their talent pipeline and accomplish specific deliverables across departments - including sales, marketing, technology, HR, and finance. "

            title02 = "Test-drive talent"
            text02 = "Industry projects improve hiring outcomes by allowing companies to authentically evaluate skills and work ethic upfront. Both employers and candidates win by having an opportunity to do actual work with one another before committing to an internship or full-time role."
        }

        if (isMobile) {
            return (
                <div className="home2_boxx" id="v-splash2_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}
                                className={this.state.menuShow ? "mobile-menu" : "hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="section-company-detail" id="root-linkedin">
                        <section className="company-page">
                            <div className="top-ribbon">
                                <figure className="company-cover-image" id="company-cover-image"
                                    style={{backgroundImage: 'url(' + bg_outside_url + ')', backgroundPosition: '50% 25%'}}>
                                </figure>
                            </div>
                            <div className="company-overview">
                                <div className="company-photo-wrapper">
                                    <figure className="company-photo-container" id="company-photo-container">
                                        <div
                                            className="presence-entity presence-entity--size-9 pv-top-card__image">
                                            {parseInt(avatar.length) === 1 ?
                                                <span>{avatar}</span>
                                                :
                                                <img title="Avatar"
                                                     src={avatar}
                                                     className="company-entity-large"/>
                                            }
                                        </div>
                                    </figure>
                                </div>
                                <div tabIndex="0">
                                    <h1 className="org-top-card-summary__title t-24 t-black t-bold truncate"
                                        title={university.name_university}>
                                        <span dir="ltr">{university.name_university}</span>
                                    </h1>
                                    <p className="org-top-card-summary__tagline t-16 t-black">
                                        {university.tagline_university}
                                    </p>
                                    <p className="org-top-card-summary-info-list t-14 t-black--light">
                                        {university.city_university}, {university.state_university}
                                    </p>
                                </div>
                                <div
                                    className="org-top-card-summary-info-list t-14 mt4 t-black--light">
                                    <div className="org-top-card-summary-info-list__info-item">
                                        <a onClick={this.handleClick.bind(this, 'signup')}
                                           className="ember-view org-top-card-primary-actions__action">
                                            <span
                                                className="org-top-card-primary-actions__action-inner artdeco-button artdeco-button--secondary">
                                                + Sign up
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="pt5 pb3 ph4 card company-description-data">
                            <h2 className="text-heading-medium">About</h2>
                            <ul className="pv-profile-pymk__list">
                                <li className="pv-pymk-section__member-container">
                                    <div
                                        className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                        <div
                                            className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                            <img title="Avatar"
                                                 src="/static/img/appimg/org-versity-logo.png"
                                                 className="pv-pymk-section__member-image mr3 EntityPhoto-circle-3 ghost-person ember-view"/>
                                        </div>

                                    </div>
                                    <div className="pv-pymk-section__member-cta mt1">
                                        <div
                                            className="t-13 t-bold t-black mb1">&nbsp;
                                        </div>
                                        <p className="t-14">
                                            Versity increases
                                            employability by offering remote industry
                                            projects to college students and recent
                                            grads.
                                        </p>
                                    </div>
                                </li>
                                <li className="pv-pymk-section__member-container">
                                    <button onClick={this.handleClick.bind(this, '/')}
                                            role="checkbox" aria-checked="false"
                                            aria-label="Apache Kafka"
                                            id="ember1202"
                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                            type="button">
                                            <span
                                                className="artdeco-pill__text">Learn More</span>
                                    </button>
                                </li>
                            </ul>
                        </section>
                        <main id="sub-main" className="scaffold-layout__main">
                            <div className="org-life mt0  theme--mercado">
                                <div className="org-life-target-selection-tabs mh0 mt0 mb2">
                                    <section id="ember201" className="artdeco-carousel ember-view">
                                        <div
                                            className="artdeco-carousel__heading artdeco-carousel__heading--simple">
                                            <div className="artdeco-carousel__navigation ">
                                                <div id="ember202" className="artdeco-pagination artdeco-pagination--hide-pagination ember-view"></div>
                                            </div>
                                        </div>
                                        <div className="artdeco-carousel__content ph3">
                                            <ul id="ember203"
                                                className="artdeco-carousel__slider ember-view">
                                                <li style={{width: "50%"}} data-item-index="0"
                                                    className="artdeco-carousel__item active ember-view">
                                                    <div data-test-display="display"
                                                         className="artdeco-carousel__item-container">
                                                        <a onClick={this.handleTabClick.bind(this, "student")}
                                                           className={this.state.tab === "student" ? "active ember-view org-life-target-selection-tabs__tab link-without-hover-state org-life-target-selection-tabs__tab--is-active" : "ember-view org-life-target-selection-tabs__tab link-without-hover-state"}>
                                                            <h3 className="org-life-target-selection-tabs__tab-text">
                                                                Students & Grads
                                                            </h3>
                                                        </a>
                                                    </div>
                                                </li>
                                                <li style={{width: "50%"}} data-item-index="1"
                                                    className="artdeco-carousel__item ember-view">
                                                    <div data-test-display="display"
                                                         className="artdeco-carousel__item-container">
                                                        <a onClick={this.handleTabClick.bind(this, "employer")}
                                                           className={this.state.tab === "employer" ? "active ember-view org-life-target-selection-tabs__tab link-without-hover-state org-life-target-selection-tabs__tab--is-active" : "ember-view org-life-target-selection-tabs__tab link-without-hover-state"}>
                                                            <h3 className="org-life-target-selection-tabs__tab-text">
                                                                Employers
                                                            </h3>
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>
                                    <section id="ember464" className="ember-view hero-media-module">
                                        <div className="org-media-item org-media-item--is-hero-media">
                                            <div id="ember465" className="org-cropped-image artdeco-card ember-view org-media-item__cropped-image">
                                                <figure className="media-figure">
                                                    <img
                                                        src={bannerURL}
                                                        alt="" id="ember466"
                                                        className="org-cropped-image__img ember-view"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </section>
                                    <section
                                        className="org-life-custom-modules-module org-life-module__container artdeco-card">
                                        <section id="ember559" className="ember-view org-life-custom-modules-module__life-page-row">
                                            <ul className="multiple-images-preview-container single-image-preview">
                                                <li className="image-tile image-tile-1">
                                                    <img
                                                    className="feed-preview-image" data-preview-url=""
                                                    aria-label="Facebook’s post image "
                                                    src={img1URL}/>
                                                </li>
                                            </ul>

                                            <div className="block-fre">
                                                <h4 className="inline-title t-16 t-black t-bold mb3"
                                                    dir="ltr">
                                                    {title01}
                                                </h4>
                                                <p className="org-life-custom-modules-module__inline-body white-space-pre-wrap t-14 t-black--light t-normal"
                                                   dir="ltr">{text01}</p>
                                            </div>

                                        </section>

                                        <section id="ember563"
                                                 className="ember-view org-life-custom-modules-module__life-page-row">
                                            <ul className="multiple-images-preview-container single-image-preview">
                                                <li className="image-tile image-tile-1">
                                                    <img
                                                        className="feed-preview-image"
                                                        aria-label="Facebook’s post image "
                                                        src={img2URL}/>
                                                </li>
                                            </ul>
                                            <div className="block-fre">
                                                <h4 className="inline-title t-16 t-black t-bold mb3"
                                                    dir="ltr">
                                                    {title02}
                                                </h4>
                                                <p className="org-life-custom-modules-module__inline-body white-space-pre-wrap t-14 t-black--light t-normal"
                                                   dir="ltr">{text02}</p>
                                            </div>
                                        </section>
                                    </section>
                                </div>
                            </div>
                        </main>

                    </div>
                </div>
            )
        }

        return (
            <div>
                <div id="company">
                    <header>
                        <div className="header">
                            <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                            <Splash_Signin type="0" url="/code/apis.php"/>
                        </div>
                    </header>
                </div>
                <div id="content" className="no-marging-top">
                    <div className="container section-company-detail root-linkedin" id="root-linkedin">
                        <div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
                            <main id="main" className="scaffold-layout__main">
                                <section id="ember3348" className="artdeco-card ember-view pv-top-card">
                                    <div className="live-video-hero-image"
                                         style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
                                        <div tabIndex="0" aria-label="Profile background"
                                             className="profile-background-image">
                                            <div className="profile-background-image__image-container">
                                                <img
                                                    className="profile-background-image__image relative full-width full-height"
                                                    id="profile-background-image-target-image"
                                                    alt="Background Image"
                                                    src={bg_outside_url}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ph5 pb5">
                                        <div className="display-flex pv-top-card--reflow">
                                            <div className="pv-top-card--photo text-align-left">
                                                <div className="pv-top-card__photo-wrapper ml0">
                                                    <div
                                                        className="presence-entity presence-entity--size-9 pv-top-card__image">
                                                        {parseInt(avatar.length) === 1 ?
                                                            <span>{avatar}</span>
                                                            :
                                                            <img title="Avatar"
                                                                 src={avatar}
                                                                 className="presence-entity__image  pv-top-card__photo  lazy-image ghost-person ember-view"/>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="pt3">
                                            <div
                                                className="org-top-card__primary-content org-top-card-primary-content--zero-height-logo org-top-card__primary-content--ia">
                                                <div className="block mt2">
                                                    <div>
                                                        <h1 className="org-top-card-summary__title t-24 t-black t-bold truncate"
                                                            title={university.name_university}>
                                                            <span dir="ltr">{university.name_university}</span>
                                                        </h1>
                                                        <p className="org-top-card-summary__tagline t-16 t-black">
                                                            {university.tagline_university}
                                                        </p>
                                                        <p className="org-top-card-summary-info-list t-14 t-black--light">
                                                            {university.city_university}, {university.state_university}
                                                        </p>
                                                        <div
                                                            className="org-top-card-summary-info-list t-14 mt4 t-black--light">
                                                            <div className="org-top-card-summary-info-list__info-item">
                                                                <a onClick={this.handleClick.bind(this, 'signup')}
                                                                   className="ember-view org-top-card-primary-actions__action">
                                                                    <span
                                                                        className="org-top-card-primary-actions__action-inner artdeco-button artdeco-button--secondary">
                                                                        + Sign up
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <div className="scaffold-layout--static">
                                    <div className="scaffold-layout__content scaffold-layout__content--main-aside">
                                        <main id="sub-main" className="scaffold-layout__main">
                                            <div className="org-life mt0  theme--mercado">
                                                <div className="org-life-target-selection-tabs mh0 mt0 mb2">
                                                    <section id="ember201" className="artdeco-carousel ember-view">
                                                        <div
                                                            className="artdeco-carousel__heading artdeco-carousel__heading--simple">
                                                            <div className="artdeco-carousel__navigation ">
                                                                <div id="ember202"
                                                                     className="artdeco-pagination artdeco-pagination--hide-pagination ember-view"></div>
                                                            </div>
                                                        </div>
                                                        <div className="artdeco-carousel__content">
                                                            <ul id="ember203"
                                                                className="artdeco-carousel__slider ember-view">
                                                                <li style={{width: "50%"}} data-item-index="0"
                                                                    className="artdeco-carousel__item active ember-view">
                                                                    <div data-test-display="display"
                                                                         className="artdeco-carousel__item-container">
                                                                        <a onClick={this.handleTabClick.bind(this, "student")}
                                                                           className={this.state.tab === "student" ? "active ember-view org-life-target-selection-tabs__tab link-without-hover-state org-life-target-selection-tabs__tab--is-active" : "ember-view org-life-target-selection-tabs__tab link-without-hover-state"}>
                                                                            <h3 className="org-life-target-selection-tabs__tab-text">
                                                                                Students & Grads
                                                                            </h3>
                                                                        </a>
                                                                    </div>
                                                                </li>
                                                                <li style={{width: "50%"}} data-item-index="1"
                                                                    className="artdeco-carousel__item ember-view">
                                                                    <div data-test-display="display"
                                                                         className="artdeco-carousel__item-container">
                                                                        <a onClick={this.handleTabClick.bind(this, "employer")}
                                                                           className={this.state.tab === "employer" ? "active ember-view org-life-target-selection-tabs__tab link-without-hover-state org-life-target-selection-tabs__tab--is-active" : "ember-view org-life-target-selection-tabs__tab link-without-hover-state"}>
                                                                            <h3 className="org-life-target-selection-tabs__tab-text">
                                                                                Employers
                                                                            </h3>
                                                                        </a>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </section>
                                                    <section id="ember464" className="ember-view hero-media-module">
                                                        <div className="org-media-item org-media-item--is-hero-media">
                                                            <div id="ember465"
                                                                 className="org-cropped-image artdeco-card ember-view org-media-item__cropped-image">
                                                                <figure className="media-figure">
                                                                    <img
                                                                        src={bannerURL}
                                                                        alt="" id="ember466"
                                                                        className="org-cropped-image__img ember-view"/>
                                                                </figure>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <section
                                                        className="org-life-custom-modules-module org-life-module__container artdeco-card">
                                                        <section id="ember559"
                                                                 className="ember-view org-life-custom-modules-module__life-page-row display-flex">
                                                            <div
                                                                className="org-media-item org-life-custom-modules-module__life-page-row--media">
                                                                <div id="ember560"
                                                                     className="org-cropped-image artdeco-card org-cropped-image--has-fixed-ratio ember-view org-media-item__cropped-image">
                                                                    <div
                                                                        style={{backgroundImage: 'url(' + img1URL + ')'}}
                                                                        className="org-cropped-image__cover-image background-image">
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="flex-1">
                                                                <h4 className="inline-title t-16 t-black t-bold mb3"
                                                                    dir="ltr">
                                                                    {title01}
                                                                </h4>
                                                                <p className="org-life-custom-modules-module__inline-body white-space-pre-wrap t-14 t-black--light t-normal"
                                                                   dir="ltr">{text01}</p>
                                                            </div>

                                                        </section>

                                                        <section id="ember563"
                                                                 className="ember-view org-life-custom-modules-module__life-page-row display-flex">
                                                            <div
                                                                className="org-media-item is-video org-life-custom-modules-module__life-page-row--media">
                                                                <div>
                                                                    <div
                                                                        className="org-youtube-player artdeco-card org-media-item__youtube-player organization-youtube-player org-media-item__fixed-youtube">
                                                                        <div
                                                                            className="org-youtube-player__thumbnail-container artdeco-card">
                                                                            <img
                                                                                src={img2URL}
                                                                                className="org-youtube-player__preview-image"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex-1">
                                                                <h4 className="inline-title t-16 t-black t-bold mb3"
                                                                    dir="ltr">
                                                                    {title02}
                                                                </h4>
                                                                <p className="org-life-custom-modules-module__inline-body white-space-pre-wrap t-14 t-black--light t-normal"
                                                                   dir="ltr">{text02}</p>
                                                            </div>
                                                        </section>
                                                    </section>
                                                </div>
                                            </div>
                                        </main>
                                        <aside className="scaffold-layout__aside">
                                            <div id="ember83" className="pv-deferred-area mt4 ember-view">
                                                <div className="pv-deferred-area__content">
                                                    <div className="artdeco-card">
                                                        <section className="pt5 pb3 ph4">
                                                            <h2 className="text-heading-medium">About</h2>
                                                            <ul className="pv-profile-pymk__list">
                                                                <li className="pv-pymk-section__member-container">
                                                                    <div
                                                                        className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                                                        <div
                                                                            className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                                                            <img title="Avatar"
                                                                                 src="/static/img/appimg/org-versity-logo.png"
                                                                                 className="pv-pymk-section__member-image mr3 EntityPhoto-circle-3 ghost-person ember-view"/>
                                                                        </div>

                                                                    </div>
                                                                    <div className="pv-pymk-section__member-cta mt1">
                                                                        <div
                                                                            className="t-13 t-bold t-black mb1">&nbsp;
                                                                        </div>
                                                                        <p className="t-14">
                                                                            Versity increases
                                                                            employability by offering remote industry
                                                                            projects to college students and recent
                                                                            grads.
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                                <li className="pv-pymk-section__member-container">
                                                                    <button onClick={this.handleClick.bind(this, '/')}
                                                                            role="checkbox" aria-checked="false"
                                                                            aria-label="Apache Kafka"
                                                                            id="ember1202"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button">
                                                                        <span
                                                                            className="artdeco-pill__text">Learn More</span>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </section>
                                                    </div>
                                                </div>
                                            </div>
                                        </aside>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

UniversityProfilePage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
const mapStateToProps = function (store) {
    return {
        user: store.userState.user,
        socket: store.msgState.socket
    };
};

export default connect(mapStateToProps)(withRouter(UniversityProfilePage));


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/university-profile.js
 **/